import { IToastSetting, Toast } from "../display/Toast.js";
import { event } from "./EventUtil.js";
import { object } from "./ObjectUtil.js";

class ClipboardClass {
    private _showToastMessage: boolean = true;

    /**
     * @deprecated Use bind() instead
     */
    private _enableDataProperty: boolean = false;

    /**
     * @deprecated Use bind() instead
     */
    private _dataPropertyListener: DisposableObject = null;

    /**
     * @deprecated Use bind() instead
     */
    public get enableDataProperty(): boolean {
        console.warn("e5.Clipboard.enableDataProperty is deprecated. Use e5.Clipboard.bind() instead.");

        return this._enableDataProperty;
    }

    /**
     * @deprecated Use bind() instead
     */
    public set enableDataProperty(attribue: boolean) {
        console.warn("e5.Clipboard.enableDataProperty is deprecated. Use e5.Clipboard.bind() instead.");

        if (this._enableDataProperty == attribue) {
            return;
        }
        this._enableDataProperty = attribue;

        if (this._dataPropertyListener) {
            this._dataPropertyListener.dispose();
            this._dataPropertyListener = null;
        }

        if (attribue) {
            this._dataPropertyListener = this.bind({
                attribute: "data-copyclipboard",
                toastMessage: (text: string) => {
                    if (!this.showToastMessage) {
                        return "";
                    }
                    return "In Zwischenablage kopiert";
                },
                toastOptions: {
                    duration: 1
                }
            });
        }
    }

    public bind(options: {
        attribute?: string;
        toastMessage?: true | string | ((text: string, element: HTMLElement) => string);
        toastOptions?: IToastSetting;
    } = {}): DisposableObject {

        options = object.merge({
            toastMessage: true,
            attribute: "data-e5-copy-clipboard"
        }, options);

        return event.on({
            type: "click",
            selector: `[${options.attribute}]`,
            listener: (e) => {
                var text = e.target.getAttribute(options.attribute);
                if (text) {
                    this.copy(text);

                    if (options.toastMessage) {
                        let o: IToastSetting = {
                            key: "e5-wordpress-clipboard-util",
                            duration: 2
                        };
                        if (options.toastOptions) {
                            o = object.merge(o, options.toastOptions);
                        }

                        if (options.toastMessage === true) {
                            o.message = "In Zwischenablage kopiert";
                            Toast.show(o);
                        } else if (typeof options.toastMessage === "string") {
                            o.message = options.toastMessage;
                            Toast.show(o);
                        } else if (typeof options.toastMessage === "function") {
                            o.message = options.toastMessage(text, e.target);
                            Toast.show(o);
                        }
                    }
                }
            }
        });
    }

    /**
     * @deprecated Use bind() instead
     */
    public get showToastMessage(): boolean {
        console.warn("e5.Clipboard.showToastMessage is deprecated. Use e5.Clipboard.bind() instead.");

        return this._showToastMessage;
    }

    /**
     * @deprecated Use bind() instead
     */
    public set showToastMessage(value: boolean) {
        console.warn("e5.Clipboard.showToastMessage is deprecated. Use e5.Clipboard.bind() instead.");
        
        this._showToastMessage = value;
    }

    private copyFallback(text: string) {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            // var msg = successful ? 'successful' : 'unsuccessful';
            // console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.warn('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }

    public copy(text: string) {
        if (!navigator.clipboard) {
            this.copyFallback(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
            // console.log('Async: Copying to clipboard was successful!');
        }, function (err) {
            console.warn('Async: Could not copy text: ', err);
        });
    }
}

export const Clipboard = new ClipboardClass();